// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"ca0098fd","453":"43347290","901":"601a3ecb"}[chunkId] + ".chunk.js";
};